
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/know-how",
      function () {
        return require("private-next-pages/know-how.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/know-how"])
      });
    }
  